<template>
    <v-container>
        <v-card class="mx-auto" flat>
            <v-row>
                <v-col>
                    <p class="headline font-weight-bold" style="color:#1E2F4C; font-size: 27px !important;">
                      Publicación de Edictos
                    </p>
                </v-col>
            </v-row>
            <v-divider class="mb-2"></v-divider>

            <v-row>
                <v-col align="right">
                    <v-btn
                      tile
                      small
                      color="#1E2F4C"
                      dark
                      to="/sentencias"
                    >
                        <v-icon left>
                            mdi-magnify
                        </v-icon>
                        Consultar Edictos
                    </v-btn>
                </v-col>
            </v-row>

            <div class="parrafo mt-2">
                <p>
                    En cumplimiento a lo dispuesto por el artículo 17 de la <b>Ley para la Declaración Especial de Ausencia por Desaparición de Personas del Estado de Jalisco </b>, se lleva a cabo la siguiente publicación de Edictos
                </p>
            </div>

        </v-card>
    </v-container>
</template>

<script>
    import axios from "axios";

    export default {
    data: () => ({
        //panel: [0, 1],
        //disabled: false,
        readonly: true,
    }),
    mounted(){
    },
    methods:{
    }
  }
</script>

<style scoped>
    .parrafo {
        color: #000000;
        font-size: 15px;
        text-align: justify;
        font-family: inherit;
        font-weight: normal;
        line-height: 1.6;
        margin-bottom: 17px;
    }
</style>
